module.exports = __webpack_public_path__ + "static/media/100 colores.5fde579f.png";